import type { KeyboardEvent } from 'react';

export const handleKeyDown = (
  event: KeyboardEvent<HTMLDivElement>,
  callback: any,
) => {
  if (event.key === 'Enter') {
    event.preventDefault();
    callback();
  }
};
